// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};

export const firebaseConfig = {
  apiKey: 'AIzaSyCV6evjeV2lzSIrJNxvxGZ_J4VweDzqb8E',
  authDomain: 'haythoo85.firebaseapp.com',
  databaseURL: 'https://haythoo85.firebaseio.com',
  projectId: 'haythoo85',
  storageBucket: 'haythoo85.appspot.com',
  messagingSenderId: '641279071428',
  appId: '1:641279071428:web:733a745163f0d78a536591',
  measurementId: 'G-HPBVVH9D8H'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
